export class RateType {
    constructor() {
        this.name = null;
        this.code = null;
        this.is_package=false;
        this.roomTypes = [];
        return this;
    }

    toViewModel(responseModal) {
        
        this.id = responseModal.id;
        this.name = responseModal.name;
        this.code = responseModal.code;
       
            this.roomTypes = responseModal.roomTypes.map(a => {
                let roomtype=new Object();
                roomtype.id=a.id;
                roomtype.rack_rate=a.room_rate_type.rack_rate;
                roomtype.extra_adult=a.room_rate_type.extra_adult;
                roomtype.extra_child=a.room_rate_type.extra_child;
                return roomtype
            });
       
        return this;
    }

    toRequestModel() {
        
        let tempRateType = {};
        tempRateType.name = this.name;
        tempRateType.code = this.code;
        tempRateType.is_package = this.is_package;
        tempRateType.roomTypes = this.roomTypes.map(a => {
            let roomtype=new Object();
            roomtype.room_type_id=a.id;
            roomtype.rack_rate=a.rack_rate;
            roomtype.extra_adult=a.extra_adult;
            roomtype.extra_child=a.extra_child;
            
            return roomtype
        });
        return tempRateType;
    }
}